import React, { useState } from 'react';
import { LuDownload } from 'react-icons/lu';
import Button from './Button';
import Logger from '../../utils/logger';

/**
 * Secondary button that runs an async download (Excel export) and shows a spinner meanwhile.
 */
function DownloadButton({ onDownload, className = '', size = 'sm', children }) {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    try {
      setIsLoading(true);
      await onDownload();
    } catch (error) {
      Logger.error('Download failed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="secondary"
      size={size}
      onClick={handleClick}
      loading={isLoading}
      leftIcon={<LuDownload className="size-4" />}
      className={className}
    >
      {children || 'Download Excel'}
    </Button>
  );
}

export default DownloadButton;
